<template>
  <div class="row align-items-center mb-4">
    <b-col sm>
      <div class="d-flex align-items-center">
        <p class="h6 mb-0">{{ $t("lang.label_certificate_resultsFound", [totalRows]) }}</p>
        <b-link class="c-pill ml-3" @click.prevent="clearSelection()" v-show="selectedItems.length > 0">
          <span>{{ selectedItems.length }} {{ $t("lang.label_certificate_itemsSelected") }}</span>
          <mtg-icon icon="ic-cross" viewBox="0 0 18 18"></mtg-icon>
        </b-link>
      </div>
    </b-col>
    <b-col sm class="col-sm-auto mt-3 mt-sm-0">
      <div class="d-flex">
        <certificate-datatable-columns-dropdown v-model="columnsVisible"></certificate-datatable-columns-dropdown>
        <b-dropdown id="multi-action-dropdown" :disabled="!selectedItems.length" title="Please select certificates to perform any action" variant="primary" right text="Actions" class="m-md-2">
          <template v-slot:button-content>
            {{ $t("lang.label_certificate_actions") }}
          </template>
          <b-dropdown-item @click="downloadMultiple()">
            <span>{{ $t("lang.label_certificate_download_selected") }}</span>
          </b-dropdown-item>
          <b-dropdown-item @click="downloadCsv()">
            <span>{{ $t("lang.label_certificate_download_asCsv") }}</span>
          </b-dropdown-item>
          <b-dropdown-item @click="revokeMultiple()">
            <span>{{ $t("lang.label_certificate_revoke_selected") }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </b-col>
  </div>
</template>
<script>
import CertificateDatatableColumnsDropdown from "./CertificateDatatableColumnsDropdown";
import * as utils from "@/utils";

export default {
  name: "CertificateDatatableHeader",
  props: {
    totalRows: {
      type: Number,
      required: true
    }
  },
  computed: {
    /* Bind values to store */
    selectedItems: {
      get: function() {
        return this.$store.getters["certificate/selectedCertificates"];
      },
      set: function(newValue) {
        this.$store.dispatch("certificate/setSelectedCertificates", newValue);
      }
    },
    columnsVisible: {
      get: function() {
        return this.$store.getters["certificate/columnsVisible"];
      },
      set: function(newValue) {
        this.$store.dispatch("certificate/setColumnsVisible", newValue);
      }
    }
  },
  methods: {
    // TODO: Only emit 'download-csv', 'download-zip' and 'revoke' events here - handle it in the parent component.
    downloadCsv() {
      this.$store
        .dispatch("certificate/downloadCsv", { certIds: this.selectedItems })
        .then(csvContent => {
          utils.downloadPlainFile("certificates.csv", csvContent, "text/csv");
        })
        .catch(() => {
          this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_download_csv_error_message"));
        });
    },
    downloadMultiple() {
      this.$store
        .dispatch("certificate/downloadMultipleCertificates", { certIds: this.selectedItems })
        .then(response => {
          utils.downloadBase64File("certificates.zip", response.data.zipFileInBase64, "application/zip");
        })
        .catch(() => {
          this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_download_zip_error_message"));
        });
    },
    revokeMultiple() {
      this.$bvModal
        .msgBoxConfirm(this.$t("lang.message_certificate_multiple_revoke_confirmation_message"))
        .then(value => {
          if (value) {
            this.$store
              .dispatch("certificate/revokeMultipleCertificates", { certIds: this.selectedItems })
              .then(response => {
                if (response.data) {
                  this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_certificate_multiple_revoke_success_message"));
                } else {
                  this.$store.dispatch("alert/showInfoAlert", this.$t("lang.message_certificate_multiple_already_revoked_expired_message"));
                }
                // Reload
                this.$router.go();
              })
              .catch(e => {
                if (e.response.data.message === "Certificate is already revoked or expired.") {
                  this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_multiple_already_revoked_expired_message"));
                } else {
                  this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_multiple_revoke_error_message"));
                }
              });
          }
        })
        .catch(() => {});
    },
    clearSelection() {
      this.$store.dispatch("certificate/setSelectedCertificates", []);
    }
  },
  components: {
    CertificateDatatableColumnsDropdown
  }
};
</script>
